// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"342":"6ba01260","639":"cf452f0f","704":"18185e68","864":"4d6f6bd7"}[chunkId] + ".chunk.css";
};